module.exports = __webpack_public_path__ + "static/img/logo.054ff16f.png";